import { fontCSS, defaultState } from 'components/v2/common.styled';
import styled from 'styled-components';

export const Container = styled.div<{ $positionStatic?: boolean; $maxMenuHeight?: string }>`
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow:
    0px 8px 12px 0px rgba(10, 13, 61, 0.08),
    0px 1px 4px 0px rgba(10, 13, 61, 0.12),
    0px 1px 4px 1px rgba(67, 71, 146, 0.16);
  padding: 12px;
  margin: 7px 0 0 0;
  top: 100%;
  max-height: ${({ $maxMenuHeight }) => $maxMenuHeight || '370px'};
  overflow: auto;
  position: ${({ $positionStatic }) => ($positionStatic ? 'static' : 'absolute')};
  background: white;
  z-index: ${({ theme }) => theme.layers.overlay};
  width: 100%;
`;

export const OptionList = styled.div`
  margin: 8px 0 0 0;
`;

export const OptionStyled = styled.div<{ 'aria-selected'?: boolean }>`
  padding: 12px 16px;
  ${fontCSS}
  color: ${defaultState.textColor};
  line-height: 24px;
  cursor: pointer;
  border-radius: 4px;

  ${({ 'aria-selected': isSelected, theme }) =>
    isSelected &&
    `
    background: ${theme.colors.blue.lightestBlue};
  `}

  &:hover {
    background: ${({ theme, 'aria-selected': isSelected }) =>
      isSelected ? theme.colors.blue.lightestBlue : theme.colors.neutral.lavenderWhite};
  }
`;

export const SearchContainer = styled.div`
  position: relative;
`;
